<template>
  <div>
    <el-container>
      <div id="header">
        <div class="headerWrap">
          <div class="welcome titleName">欢迎来到甘肃煤炭交易中心官网!</div>
          <div class="welcome titlePhone">客服热线：0931-5116320</div>
          <div class="cb"></div>
        </div>
      </div>
      <el-header>
        <Header></Header>
      </el-header>
      <el-main style="min-height: 500px;">
        <router-view></router-view>
      </el-main>
      <el-footer>
        <Footer></Footer>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import Footer from "../components/Footer";
import Header from "../components/Header";

export default {
  name: "Home",
  components: { Footer, Header },
  created() {},

  data() {
    return {
      activeIndex: "/gctc-portalsite",
      gctcStatus: false,
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
#header {
  background: #eee;
  // height: 38px;
}
.headerWrap {
  width: 1200px;
  margin: 0 auto;
}
.welcome {
  color: #333;
  line-height: 38px;
}
.titleName {
  float: left;
}
.titlePhone {
  float: right;
}
.el-header {
  background-color: #fff;
  min-height: 204px !important;
  // text-align: center;
  padding: 0;
}

.el-footer {
  background-color: #fff;
  padding: 0;
  // text-align: center;
  // line-height: 60px;
}

.el-main {
  background-color: #fff;
  color: #333;
  // text-align: center;
  // height: 500px;
  // line-height: 160px;
  padding: 0;
  margin-top:3.5px;
}

// body > .el-container {
//   margin-bottom: 40px;
// }

// .el-container:nth-child(5) .el-aside,
// .el-container:nth-child(6) .el-aside {
//   line-height: 260px;
// }

// .el-container:nth-child(7) .el-aside {
//   line-height: 320px;
// }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/views/Home.vue